<div class="st-div">

    <h1 style="text-align: center; font-weight: bold;color: #ffffff; padding-top: 1.5%;" translate>cmis</h1>
    <span layout="row">
      <hr class="st-hr" flex/>
    </span>


    <div class="content">
        <div fxLayout="row wrap"
             fxLayoutGap=" grid"
             style="justify-content: center;flex-flow: row wrap;box-sizing: border-box;display: flex;margin: 0px -23px -76px 0px;">
            <div class="st-div-height" fxFlex="20%" fxFlex.sm="33%" fxFlex.xs="100%">
                <a [routerLink]="['/portail/cmis_Lois']" class="st-p">
                    <mat-card class="mat-elevation-z0 st-matcard">
                        <img class="st-matcardimage" mat-card-image src="assets/images/lois.svg">
                        <mat-card-content>
                            <p class="st-p">
                                {{ "Lois" | translate}}
                            </p>
                        </mat-card-content>
                    </mat-card>
                </a>
            </div>

            <div class="st-div-height" fxFlex="20%" fxFlex.sm="33%" fxFlex.xs="100%">
                <a [routerLink]="['/portail/cmis_Decrets']" class="st-p">
                    <mat-card class="mat-elevation-z0 st-matcard">
                        <img class="st-matcardimage" mat-card-image src="assets/images/décret.svg">
                        <mat-card-content>

                            <p class="st-p">
                                {{ "Decrets" | translate}}

                            </p>
                        </mat-card-content>
                    </mat-card>
                </a>
            </div>
            <div class="st-div-height" fxFlex="20%" fxFlex.sm="33%" fxFlex.xs="100%">

                <mat-card class="mat-elevation-z0 st-matcard">
                    <a [routerLink]="['/portail/cmis_Arretes']" class="st-p">
                        <img class="st-matcardimage" mat-card-image src="assets/images/arretes.svg">
                        <mat-card-content>

                            <p class="st-p">
                                {{ "Arretes" | translate}}

                            </p>
                        </mat-card-content>
                    </a>
                </mat-card>
            </div>
            <div class="st-div-height" fxFlex="20%" fxFlex.sm="33%" fxFlex.xs="100%">
                <a [routerLink]="['/portail/cmis_manuel']" class="st-p">
                    <mat-card class="mat-elevation-z0 st-matcard">
                        <img class="st-matcardimage" mat-card-image src="assets/images/arretes.svg">
                        <mat-card-content>


                            <p class="st-p">
                                {{ "Manuel_utilisations" | translate}}

                            </p>

                        </mat-card-content>
                    </mat-card>
                </a>
            </div>
            <div class="st-div-height" fxFlex="20%" fxFlex.sm="33%" fxFlex.xs="100%">
                <a [routerLink]="['/portail/cmis_Autres']" class="st-p">

                    <mat-card class="mat-elevation-z0 st-matcard">
                        <img class="st-matcardimage" mat-card-image src="assets/images/autres.svg">
                        <mat-card-content>

                            <p class="st-p">
                                {{ "Autres" | translate}}

                            </p>
                        </mat-card-content>
                    </mat-card>
                </a>
            </div>
        </div>
    </div>
    <div class="div-matdiv"></div>
</div>
